import React from 'react';
import Navbar from '../../components/navbar/Navbar';
import { Box } from '@mui/material';
import Landing from '../../components/home_page/landing/Landing';
import Footer from '../../components/Footer/Footer';

const HomePage = () => {
	return (
		<Box>
			<Navbar />
			<Landing />
			<Footer />
		</Box>
	);
};

export default HomePage;
